import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xs-12 col-lg-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Bezoek afgelopen 7 dagen:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Pagina"),
  /*#__PURE__*/_createElementVNode("th", null, "Bezoeken")
], -1)
const _hoisted_6 = { class: "col-xs-12 col-lg-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "Bezoek afgelopen 28 dagen:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Pagina"),
  /*#__PURE__*/_createElementVNode("th", null, "Bezoeken")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_page_subtitle = _resolveComponent("page-subtitle")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_spinner, { loaded: _ctx.loaded }, null, 8, ["loaded"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_page_title, { text: "Gebruiksstatistieken" }),
        _createVNode(_component_page_subtitle, { text: "Hoevaak worden paginas bezocht?" })
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("table", null, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataWeek, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.key
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.key), 1),
                  _createElementVNode("td", null, _toDisplayString(item.count), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("table", null, [
            _hoisted_8,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataMonth, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.key
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.key), 1),
                  _createElementVNode("td", null, _toDisplayString(item.count), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.loaded]
      ])
    ]),
    _: 1
  }))
}